import axios from '@/util/request';

export function getFetchPageLst(parameter) {
    //获取出入库记录
    return axios({
        url: '/ims/fetchRecord/page',
        method: 'get',
        params: parameter,
    })
}

export function getFreeLst(parameter) {
    //获可以取出的仪器
    return axios({
        url: '/ims/fetchRecord/getFreeLst',
        method: 'get',
        params: parameter,
    })
}

export function createFetch(data) {
    //获可以取出的仪器
    return axios({
        url: '/ims/fetchRecord/create',
        method: 'post',
        data: data
    })
}

export function deleteFetch(fetchId) {
    //获可以取出的仪器
    return axios({
        url: '/ims/fetchRecord/delete',
        method: 'delete',
        params: { 'fetchId': fetchId }
    })
}

export function deleteDetail(detailId) {
    //获可以取出的仪器
    return axios({
        url: '/ims/fetchRecord/deleteDetail',
        method: 'delete',
        params: { 'detailId': detailId }
    })
}

export function getFetchDetails(fetchId) {
    //获可以取出的仪器
    return axios({
        url: '/ims/fetchRecord/getDetails',
        method: 'get',
        params: { 'fetchId': fetchId }
    })
}


// WEBPACK FOOTER //
// ./src/api/fetchApi.js